import { render, staticRenderFns } from "./checked_faild.vue?vue&type=template&id=0b568cba&scoped=true&"
import script from "./checked_faild.vue?vue&type=script&lang=js&"
export * from "./checked_faild.vue?vue&type=script&lang=js&"
import style0 from "./checked_faild.vue?vue&type=style&index=0&id=0b568cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b568cba",
  null
  
)

export default component.exports